import { Button, Col, Row } from "react-bootstrap";
import { FiChevronLeft } from 'react-icons/fi'
import { statiSondaggio } from "../../Utilities/statiElementEnum";
/*
props passate:
setMostraTabella={props.setMostraTabella}
                    sonStato={sonStato}
                    handleSubmit={handleSubmit}
*/

export default function AzioniSondaggio(props){
const handleBackOrCancel = () => {
        if (props.onCancel) { // If onCancel is provided (for new survey cancellation)
            props.onCancel();
        } else {
            props.setMostraTabella(true); // Default behavior
        }
    };
    return(
        <>
            <Row className="mt-3 mb-5">
                <Col xs={{span:12, order:3}} md={{span:2, order:1}}>
                    <Button variant="outline-secondary" onClick={handleBackOrCancel}>
                    {props.isNewSondaggio ? "Annulla" : "Indietro"}
                </Button>
                </Col>
                {
                    props.sonStato === statiSondaggio.NonPubblicato &&
                    <>
                        <Col xs={{span:12, order:2}} md={{span:2, offset:6, order:2}}>
                            <Button className="w-100 my-2 my-md-1 shadow"
                                    type="submit" variant="outline-secondary"
                                    onClick={
                                        e=>{
                                            props.handleSubmit("salva-bozza", e)
                                        }
                                    }
                            >
                                Salva bozza
                            </Button>
                        </Col>
                        <Col xs={{span:12, order:2}} md={{span:2, order:2}}>
                            <Button className="w-100 my-2 my-md-1 shadow"
                                    type="submit"
                                    onClick={
                                        e=> {
                                            props.handleSubmit("pubblica", e)
                                        }
                                    }
                            >
                                Salva e pubblica
                            </Button>
                        </Col>
                    </>
                }
                {
                    [statiSondaggio.InCorso, statiSondaggio.Concluso, statiSondaggio.Pubblicato].includes(props.sonStato) &&
                    <Col xs={{span:12, order:1}} md={{span:2, offset:8, order:2}}>
                        <Button className="w-100 my-2 my-md-1 shadow"
                                variant="primary" type="submit"
                                onClick={
                                    e => {
                                        props.handleSubmit("salva", e)
                                    }
                                }>
                            Salva
                        </Button>
                    </Col>
                }
            </Row>
        </>

    )
}